export default __webpack_public_path__ + "static/media/favicon-16x16.5dbf916a.png";